var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramThumbUp40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,16.60155 C0,20.6346391 3.56341,20.5110223 4.269185,20.5110223 C5.72478,20.5110223 11.986445,20.5110223 11.986445,20.5110223 C12.90648,20.5110223 13.948765,19.8936907 14.246815,18.8365751 C15.446885,14.5802414 17,10.2327433 17,9.04891953 C17,7.8651007 16.086895,6.8372093 14.60826,6.8372093 L7.519005,6.8372093 C8.249415,5.29288884 8.770535,3.74647326 8.770535,2.43949674 C8.770535,1.02447767 8.22267,0.00841953488 6.996905,0.00841953488 C5.771145,0.00841953488 5.45666,1.00617837 5.01786,1.97844419 C4.209505,3.76954884 2.503725,6.84338721 0,6.84338721 L0,16.60155 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 6 0 6 14 0 14"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features-and-Benefits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.5 -2.43344093 19.5 -2.43344093 19.5 22.9532935 -2.5 22.9532935"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5,16.1860392 C5,20.1201864 8.563409,19.9995977 9.269185,19.9995977 C10.72478,19.9995977 16.986445,19.9995977 16.986445,19.9995977 C17.90648,19.9995977 18.948765,19.3974115 19.246815,18.3662309 C20.446885,14.2143208 22,9.97348302 22,8.8187029 C22,7.66392754 21.086895,6.66125414 19.60826,6.66125414 L12.519005,6.66125414 C13.249415,5.15482161 13.770535,3.64634392 13.770535,2.37143193 C13.770535,0.991131405 13.22267,0 11.996905,0 C10.771145,0 10.45666,0.973278671 10.01786,1.92169357 C9.209503,3.66885338 7.5037245,6.66728048 5,6.66728048 L5,16.1860392 Z",
    id: "Stroke-4",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFCC00",
    mask: "url(#mask-4)",
    points: "-2.5 -2.5 8.5 -2.5 8.5 16.5 -2.5 16.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-8",
    stroke: "#4F4C4D",
    points: "0 20 6 20 6 6 0 6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramThumbUp40);
export default __webpack_public_path__ + "static/media/pictogramThumbUp40.717cb8b6ca5e9ca1f73341ef7d5c53cb.svg";
export { ForwardRef as ReactComponent };